import apiClient from './client';
import { resolveFileUrl } from '../lib/fileUrls';

export const mapPointsAPI = {
  list: (evaluationId) =>
    apiClient.get(`/map-points?evaluation_id=${evaluationId}`)
      .then(r => ({ ...r, data: Array.isArray(r.data) ? r.data : (r.data.items || []) })),
  create: (data) => apiClient.post('/map-points', data),
  update: (id, data) => apiClient.put(`/map-points/${id}`, data),
  remove: (id) => apiClient.delete(`/map-points/${id}`),
  uploadPhoto: (id, file) => {
    const formData = new FormData();
    formData.append('file', file);
    return apiClient.post(`/map-points/${id}/photo`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
};

// #Fase0-B5 — la foto del marcador ya se sube a Cloudinary y la API guarda
// la URL completa (https://res.cloudinary.com/...). Antes se le anteponía
// siempre el host de la API y quedaba "https://api.soempg.com/https://res..."
// → la foto nunca cargaba. resolveFileUrl deja intactas las URL absolutas y
// solo arma la ruta para registros viejos con ruta relativa.
export const photoUrl = (url) => resolveFileUrl(url, 'map_point');
